// extracted by css-extract-rspack-plugin
export default {"tableQuickFilters":"TableQuickFilters_tableQuickFilters__cjkv0 custom-scrollbar"};